export default __webpack_public_path__ + "static/link-item-do-3f9bb242aab6b860129d432793b3fb236c05d8c95310873f87bee260ec9071ed.png";